<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
[{"num_cand":"U2FsdGVkX1/VKLxRrnFMx+D6fgwm5Sc3sNLSLFOglQg=","cpf":"U2FsdGVkX1+1cQlj9cHQvnRG5odNbuZFbKC3RSp3PIw="},{"num_cand":"U2FsdGVkX1985Yc2dCp6QpDO8XlWT0Xc7T0JtcFRv40=","cpf":"U2FsdGVkX18W4T0IEXU8MUP1IDl4LXZDbHqzyHwhaaE="},{"num_cand":"U2FsdGVkX1+Jadz4c6VYY5fqhjEu8RSXZie5wAwoZLo=","cpf":"U2FsdGVkX1+8DazET7e29lyLLuUSYbN+iJoH0DlqVVk="},{"num_cand":"U2FsdGVkX1/cy8fx841r2rOKr/JrR6AwkBAV0gcJEds=","cpf":"U2FsdGVkX18FVcSHFVJjX3o/wwMkbsp/XkM1z5oK17E="},{"num_cand":"U2FsdGVkX18lfX1Fez0YVu5Onq/k7yQdAdc/j+ukNYA=","cpf":"U2FsdGVkX18av+fUwnMeZWz05pKiDuF3TjI7cxKQfCI="},{"num_cand":"U2FsdGVkX19R8LjneClla9oRWLUCDkbrVF5YctjdMsk=","cpf":"U2FsdGVkX188B8Rh9HvXZblnRKf3YMBjhF/OS/ZGMGQ="},{"num_cand":"U2FsdGVkX189RrhKD7jQdZd1QkSGAIJl+DJl+rn01AM=","cpf":"U2FsdGVkX19U92kwL05cnvRgeazCa8GatT7qAAzcnto="},{"num_cand":"U2FsdGVkX18UygQh1/w1sXcleV4ZaBONBmUXBde83qs=","cpf":"U2FsdGVkX1+jYTtDGxYDt0nw6SBBmV8LLWs6N6rRnGc="},{"num_cand":"U2FsdGVkX1+/4zZ85W117t+KW76AN9Pqx9kZZO7HMwI=","cpf":"U2FsdGVkX18iBdJ8/xcJgsFgQ+gFg8Ifs6SiJX3TNgI="},{"num_cand":"U2FsdGVkX1+qCzw1YJkNqEU4hzosh5S3rk485VNdIQA=","cpf":"U2FsdGVkX1+8708ilmVph6hodMUGmParm3DCTS8Wbss="},{"num_cand":"U2FsdGVkX19Ru4WIhc3ehAAG5sXUr8AxqIBlCdV8Sq4=","cpf":"U2FsdGVkX18n+U2MuV84jAWyhnx95NBtdZyGPlxcEwo="},{"num_cand":"U2FsdGVkX18Vo5/ymcaKgPesMi4wXcGvnFQImYPGsfc=","cpf":"U2FsdGVkX18z9ZNagGJoHc2uVu8zJtiEztd01RXdUwc="},{"num_cand":"U2FsdGVkX19qAdr7GFr/cpgOKQqsfEABFX87c4k0zmg=","cpf":"U2FsdGVkX19ap9YScdM6lF6f5Bu2HvtHiSkEY9Ef46c="},{"num_cand":"U2FsdGVkX19TeFNLCcxuCjyXb+OXV2KXr87hps+5Gqw=","cpf":"U2FsdGVkX18+1vNjx+eCCwYTknAJaM3qK5ueXRShGHw="},{"num_cand":"U2FsdGVkX18sxu0/tfy1djA3pZm9Kbtgx7HTJ9BkU88=","cpf":"U2FsdGVkX1/0FXOTHuonZOhvSSKo3a4gtJ+T83MCeuU="},{"num_cand":"U2FsdGVkX1+cN/LYDoXAwZbN8yHJZUIiyZ9Q+SdULos=","cpf":"U2FsdGVkX1+2SLwWnTJVi0Eo/2Jd4x6whkvAJB/Aj+k="},{"num_cand":"U2FsdGVkX19omMhwEnR4KqmISOc3SrN7Bx8X3qeQJl4=","cpf":"U2FsdGVkX1/D2lpTuXU0Zif+mI8fv7zPwhUZAz00TZE="},{"num_cand":"U2FsdGVkX18+mRDmUbFZbEl8r5RXqESjmMbWUlBDvmI=","cpf":"U2FsdGVkX19v82XsEkieImwWSlw8HaWxuS1y0qlxtl4="},{"num_cand":"U2FsdGVkX1+GK8BzqZrKPl5qUS+kt2JPUownIDx0OPc=","cpf":"U2FsdGVkX19I39VoFbo69RGVDYbFU6VWBkb6qIAvL8o="},{"num_cand":"U2FsdGVkX1/vYFJQvLjFtjNmsGP8v5SDeaR0T7TKnsU=","cpf":"U2FsdGVkX18xN/7Ddxhys9gcv2gNBiL0/bbLnlM4p4Y="},{"num_cand":"U2FsdGVkX189aZ8XcRrYP39w29lfx5qVWnmmlS35fCM=","cpf":"U2FsdGVkX1+PeU0wdRBkYvMDnWzy7gP1vUCl8v+ijQY="},{"num_cand":"U2FsdGVkX19SQXrU/CDNNq0RsxwJ0B4avu4I+r5QB70=","cpf":"U2FsdGVkX1+iitKPRV5V7zvRMuCI45k/8L/4ImYaLsA="},{"num_cand":"U2FsdGVkX180o9q+0igjxw3D1Eutgbj2CPBtzmSAB8g=","cpf":"U2FsdGVkX1/AsKeSh/cba9AI1qd8dTVIx601MqM4CjE="},{"num_cand":"U2FsdGVkX18MvOUxiQZ09ZS98ujhsDQ8mVpBvX4wk+s=","cpf":"U2FsdGVkX19ona3XJoGvxwGO/obZS/gsA1b+wwEv460="},{"num_cand":"U2FsdGVkX187260MzKKh4Oq8LsjPSZizA9it+H8DWc4=","cpf":"U2FsdGVkX18FSAX+SbEcdiRiDe0/rtbwWopCokZR8jA="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/rec_res_prem/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
